var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTablet(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.98588 2.42843H6.01445M7.50017 13.1999H7.49274M5.64303 0.571289H9.35731C11.4581 0.571289 12.5093 0.571289 13.1615 1.22426C13.8145 1.87649 13.8145 2.92763 13.8145 5.02843V10.9713C13.8145 13.0721 13.8145 14.1232 13.1615 14.7755C12.5093 15.4284 11.4581 15.4284 9.35731 15.4284H5.64303C3.54223 15.4284 2.49108 15.4284 1.83885 14.7755C1.18588 14.1232 1.18588 13.0721 1.18588 10.9713V5.02843C1.18588 2.92763 1.18588 1.87649 1.83885 1.22426C2.49108 0.571289 3.54223 0.571289 5.64303 0.571289Z",
    stroke: "currentColor",
    strokeWidth: 0.891428,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTablet);
export default __webpack_public_path__ + "static/media/tablet.d75345a43883f078326e2b3549941068.svg";
export { ForwardRef as ReactComponent };